// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-sheet-page-margin {
	margin-left: 4rem;
	margin-right: 4rem;
}

.book-sheet-border {
	border-top: 1px dashed;
	margin-top: -1.2rem;
}

.book-sheet-header {
	font-size: 1.725rem;
	font-weight: 900;
}

.book-sheet-header-top {
	margin-top: 2rem;
	margin-bottom: -0.825rem;
}

.book-sheet-header-2 {
	font-size: 1.125rem;
	font-weight: 900;
}

.book-sheet-cost {
	margin-top: 6rem;
}

.book-sheet-footer {
	margin-top: 6rem;
}

.book-sheet-footer-margin {
	margin-bottom: -1.025rem;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/kbb-book-sheet.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;AACzB","sourcesContent":[".book-sheet-page-margin {\n\tmargin-left: 4rem;\n\tmargin-right: 4rem;\n}\n\n.book-sheet-border {\n\tborder-top: 1px dashed;\n\tmargin-top: -1.2rem;\n}\n\n.book-sheet-header {\n\tfont-size: 1.725rem;\n\tfont-weight: 900;\n}\n\n.book-sheet-header-top {\n\tmargin-top: 2rem;\n\tmargin-bottom: -0.825rem;\n}\n\n.book-sheet-header-2 {\n\tfont-size: 1.125rem;\n\tfont-weight: 900;\n}\n\n.book-sheet-cost {\n\tmargin-top: 6rem;\n}\n\n.book-sheet-footer {\n\tmargin-top: 6rem;\n}\n\n.book-sheet-footer-margin {\n\tmargin-bottom: -1.025rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
